import Vue from 'vue';
import Router from 'vue-router';

// components
import DashboardLayout from '@/components/layouts/DashboardLayout';
import Login from '@/components/views/Login';
import DashboardLanding from '@/components/views/DashboardLanding';
import NotFoundView from '@/components/layouts/404.vue'
import LiveAuctionLayout from '@/components/layouts/LiveAuctionLayout';
import LiveAuction from '@/components/views/Auction/LiveAuction';

// services
import authHelper from '@/helpers/auth';
import { authInstance } from '@/helpers/axios';

// helpers
import { setTitle } from '@/helpers/page-helper';
import i18n from '@/language/';

// routes
import auctionRoutes from './routes/auction-routes.js';
import manageRoutes from './routes/manage-routes.js';

Vue.use(Router);

authHelper.addResponseInterceptor(authInstance);
authHelper.addRequestInterceptor(authInstance);

const router = new Router({
	mode: 'history',
	routes: [{
			path: '',
			beforeEnter: authHelper.requireAuth,
			component: DashboardLayout,
			redirect: '/',
			children: [{
				path: '/',
				name: 'Landingpage',
				component: DashboardLanding,
				meta: {
					title: i18n.t('common.dashboard')
				}
			}]
		},
		auctionRoutes,
		manageRoutes,
		{
			path: '/login',
			name: 'Login',
			component: Login,
			meta: {
				title: i18n.t('common.login')
			}
		},
		{
			path: '*',
			component: NotFoundView
		},
		{
			path: '',
			beforeEnter: authHelper.requireAuth,
			name: 'liveAuctionLayout',
			component: LiveAuctionLayout,
			children: [{
				path: '/live-auction/:auctionId',
				name: 'liveAuction',
				component: LiveAuction
			}]
		},
	]
});

router.beforeEach((to, from, next) => {
	if (to.meta.title == undefined) {
		to.meta.title = '';
	}

	setTitle(to.meta.title);

	next();
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js